module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dragWrap",
    staticClass: "drag"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showULeft),
      expression: "showULeft"
    }],
    ref: "uLeft",
    staticClass: "item item-top up-left"
  }, [_vm._t("uLeft")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showURight),
      expression: "showURight"
    }],
    ref: "uRight",
    staticClass: "item item-top up-right"
  }, [_vm._t("uRight")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDLeft),
      expression: "showDLeft"
    }],
    ref: "dLeft",
    staticClass: "item item-down down-left"
  }, [_vm._t("dLeft")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDRight),
      expression: "showDRight"
    }],
    ref: "dRight",
    staticClass: "item item-down down-right"
  }, [_vm._t("dRight")], 2), _vm._v(" "), (_vm.options.layout == 'u-d') ? _c('div', {
    ref: "point",
    class: ['dragPoint', 'dragPointUD', {
      dragTrick: _vm.dragTrick
    }]
  }) : _c('div', {
    ref: "point",
    class: ['dragPoint', 'dragPointLR', {
      dragTrick: _vm.dragTrick
    }]
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-525d8cce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Drag/index.vue
// module id = 512
// module chunks = 1